import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const Snapchat = asyncComponent({
  resolve: () => import('./Snapchat'),
});

export default class SnapchatWrapper extends Component {
  render() {
    return(
      <div>
        <Snapchat config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.snapchat_pixel_id)} />
      </div>
    );
  }
}

SnapchatWrapper.propTypes = {
  config: PropTypes.object,
};
